<template>
  <div>
    <!-- BADGES -->
    <v-style>
      /* Use CustomerVar with example : {{ customizableVar1 }}
      Set Background Image with example :
      background-image:url('\{\{require('@/html/elements/after-page-title-0f555d.svg')}}')
      !important; */
    </v-style>
    <div id="phone">
      <div class="rdv">
          <a class="text" href="tel:0650736118">PRENDRE RDV</a>
          <a class="num" href="tel:0650736118">06<br>50<br>73<br>61<br>18</a>
      </div>
      <div class="img">
          <a href="tel:0650736118">
              <img src="@/../public/elements/phone.svg" alt="tel">
          </a>
      </div>
      <div class="img mt-5">
          <router-link tag="a"  to="contact">
              <img src="@/../public/elements/email.svg" alt="tel">
          </router-link>
      </div>
    </div>


    <header> 
      <!-- NAVBAR -->
      <nav> 
        <!-- MENU MOBILE -->
        <div class="menu-mobile"> 
            <ul class="list-unstyled">
              <template 
                v-for="(menu, index) of $parent.dataIris.menuHeader.itemsMenu.children"
              >
                <li
                  class="prestations"
                  v-if="menu.children"
                >
                  <a href="#" class="c-bleu">{{menu.name}}</a>
                  <ul class="dropdown">
                        <li
                            v-for="(sousmenu, index2) of menu.children"
                        >
                            <router-link
                            tag="a"
                            :to="'/'+sousmenu.route"
                            class="c-bleu"
                            >{{ sousmenu.labelMenu }}</router-link
                          >
                        </li>
                    </ul>
                </li>
                <li
                  class="simple"
                  v-else
                >
                  <a
                    :href="menu.route"
                    class="c-bleu"
                    >{{ menu.labelMenu }}</a>
                </li>
              </template>
            </ul>
        </div>

        <!-- MENU DESKTOP -->
        <div class="container">
            <div class="row">
                <!-- MENU RESEAUX SOCIAUX -->
                <div class="col-sm-12 col-md-5 col-lg-4 col-xl-4 ">
                    <div class="logo d-flex relative" :class="(dataPage.route == 'accueil' ? 'logo' : 'logo-sansforme')">
                        <a href="https://www.instagram.com/veronique.lesourd.3" target="new">
                          <img src="@/../public/elements/instagram.svg" alt="" class="instagram">
                        </a>
                        <a href="https://www.facebook.com/veroniquelesourdhypnosemagnetisme" target="new">
                          <img src="@/../public/elements/facebook.svg" alt="" class="facebook">
                        </a>
                        <!-- BOUTON MENU MOBILE -->
                        <img class="mobile d-md-none" src="@/../public/elements/menu-mobile.png" alt="mobile"> 
                    </div> 
                </div>
                <div class="col-sm-12 col-md-7 col-lg-8 col-xl-8  menu d-none d-md-flex flex-row justify-content-center align-self-center mt-4"> 
                    <ul class="list-unstyled list-inline d-flex align-self-baseline justify-content-center w-100">
                      <template 
                          v-for="(menu, index) of $parent.dataIris.menuHeader.itemsMenu.children"
                      
                      >
                        <li
                          class="list-inline-item prestations"
                          v-if="menu.children"
                        >
                          <a href="#" class="c-bleu">{{menu.name}}</a>
                          <ul class="dropdown">
                                <li
                                   v-for="(sousmenu, index2) of menu.children"
                                >
                                   <router-link
                                    tag="a"
                                    :to="'/'+sousmenu.route"
                                    class="c-bleu"
                                    >{{ sousmenu.labelMenu }}</router-link
                                  >
                                </li>
                            </ul>
                        </li>
                        <li
                          class="list-inline-item simple"
                          v-else
                        >
                          <router-link
                            tag="a"
                            :to="'/'+menu.route"
                            class="c-bleu"
                            >{{ menu.labelMenu }}</router-link
                          >
                        </li>
                        <li class="separation" v-if="(index+1) < $parent.dataIris.menuHeader.itemsMenu.children.length"><span></span></li>
                      </template>
                    </ul>
                </div>
            </div>
        </div>
      </nav>
    </header>
  </div>
</template>
<script>
import $ from 'jquery'
// FIREBASE
import "firebase/auth";
const firebase = require("firebase");
require("firebase/firestore");
require("firebase/auth");
var db = firebase.firestore();
import { firebaseConfig } from "@/firebase/firebaseConfig";

/*  
Exemple Import d'un element en SVG :
import IconeClock from "../html/elements/lt-icone-clock.vue";
*/

export default {
  name: "espHeader",
  components: {
    // Exemple Import d'un element en SVG : ajouter ici : IconeClock,
  },
  props: {
    dataPage: {
      type: Object,
    },
    dataIris: {
      type: Object,
    },
  },
  data() {
    return {};
  },
  computed: {
    color1: function () {
      if (this.dataIris.customizableVar[0].value) {
        return this.dataIris.customizableVar[0].value;
      } else {
        return "0f555d";
      }
    },
    color2: function () {
      if (this.dataIris.customizableVar[1].value) {
        return this.dataIris.customizableVar[1].value;
      } else {
        return "0f555d";
      }
    },
    customizableVar1: function () {
      if (this.dataIris.customizableVar[0].value) {
        return this.dataIris.customizableVar[0].value;
      } else {
        return "0f555d";
      }
    },
  },
  mounted() {

    $('.menu-mobile').css("display", "none");

    $('.mobile').click(function() {
        if($('.menu-mobile').css("display") == "none"){
            $('.menu-mobile').css("display", "block");
            $('.mobile').attr("src", "./elements/cross.svg");
            $('#photo').css("z-index", "4");
        } else {
            $('.menu-mobile').css("display", "none");
            $('.mobile').attr("src", "./elements/menu-mobile.png");
            $('#photo').css("z-index", "10");
        }
    });

  },
  methods: {
    chartStringBr(val) {
      return val.replace(" ", "<br>");
    },
  },
};
</script>
